import renderSafeHtml from "utils/renderSafeHtml";

// Only these domains may be loaded inside an iframe.
const TRUSTED_IFRAME_DOMAINS = ["trusted.example.com"];

function isTrustedIframeUrl(rawUrl) {
  try {
    const url = new URL(rawUrl);
    return (
      url.protocol === "https:" && TRUSTED_IFRAME_DOMAINS.includes(url.hostname)
    );
  } catch {
    return false;
  }
}

export default function ReferralModal({ message, onClose }) {
  if (!message) return null;

  const isUrl = message.type === "url";
  const trustedUrl =
    isUrl && isTrustedIframeUrl(message.url) ? message.url : null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="referral-modal-title"
      className="d-flex align-items-center justify-content-center"
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1080,
        padding: "1rem",
      }}
      onClick={onClose}
    >
      <div
        className="p1-bg p-4"
        style={{
          maxWidth: "520px",
          width: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
          borderRadius: "16px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
          <h4 id="referral-modal-title" className="mb-0">
            {message.title}
          </h4>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="btn p-0 border-0 bg-transparent lh-1"
            style={{ fontSize: "1.4rem" }}
          >
            ×
          </button>
        </div>

        <div className="mb-4">
          {trustedUrl ? (
            <iframe
              title={message.title || "Referral content"}
              src={trustedUrl}
              sandbox=""
              referrerPolicy="no-referrer"
              style={{
                width: "100%",
                height: "360px",
                maxHeight: "60vh",
                border: "none",
                borderRadius: "8px",
              }}
            />
          ) : isUrl ? (
            <p className="mb-0">We could not display this referral content.</p>
          ) : (
            renderSafeHtml(message.body)
          )}
        </div>

        <div className="text-end">
          <button type="button" className="cmn-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
